module.exports = __webpack_public_path__ + "img/competitors.0b3f819b.svg";